/* B-Selfie product gallery (thumbs_aside), Pinalli-style — client feedback 2026-09-24.
   Keeps the theme's Swiper instances (zoom modal, variant media still work) and only:
   - adds up/down arrows on the thumbnail column, shown on hover (desktop), wired to the main slider
   - scrolls the thumbnail column only as much as needed to keep the active thumb visible
     (the theme always snaps the active thumb to the top, hiding the first ones)
   - closes the zoom modal on a click outside the photo
   - caps the main image so the gallery fits above the fold (--pp-cap). */
(function () {
  var DESKTOP = window.matchMedia('(min-width: 1100px)');
  var chevron = function (dir) {
    return '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="' +
      (dir === 'up' ? 'M3 10.5 8 5.5l5 5' : 'M3 5.5 8 10.5l5-5') + '"/></svg>';
  };

  function patchThumbs(sub) {
    var sw = sub.swiper;
    if (!sw || sw.__ppPatched) return;
    var orig = sw.slideTo.bind(sw);
    sw.slideTo = function (index, speed, runCallbacks) {
      if (!DESKTOP.matches || !sw.slides || !sw.slides[index]) return orig(index, speed, runCallbacks);
      var box = sub.getBoundingClientRect(), r = sw.slides[index].getBoundingClientRect();
      if (r.top >= box.top - 1 && r.bottom <= box.bottom + 1) return; // already fully visible: don't move
      if (r.top < box.top) return orig(index, speed, runCallbacks);   // above: bring it to the top
      // below: bring it to the bottom edge
      var h = r.height + (parseFloat(sw.params.spaceBetween) || 0), fit = Math.max(1, Math.floor(box.height / h));
      return orig(Math.max(0, index - fit + 1), speed, runCallbacks);
    };
    sw.__ppPatched = true;
  }

  // keep the whole gallery above the fold: the main square may not be taller than the viewport below it
  function fit(outer) {
    var list = outer.querySelector('.js-media-list');
    if (!list || !DESKTOP.matches) { outer.style.removeProperty('--pp-cap'); return; }
    var top = list.getBoundingClientRect().top + window.scrollY;
    outer.style.setProperty('--pp-cap', Math.max(360, Math.round(window.innerHeight - top - 24)) + 'px');
  }

  function setup(outer) {
    fit(outer);
    var sub = outer.querySelector('.js-media-sublist'), main = outer.querySelector('.js-media-list');
    var wrap = outer.querySelector('.product__media-sublist-outer');
    if (!sub || !main || !wrap) return;
    patchThumbs(sub);
    if (!wrap.querySelector('.pp-thumbs-nav')) {
      ['prev', 'next'].forEach(function (d) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pp-thumbs-nav pp-thumbs-nav--' + d;
        b.setAttribute('aria-label', d === 'prev' ? 'Immagine precedente' : 'Immagine successiva');
        b.innerHTML = chevron(d === 'prev' ? 'up' : 'down');
        b.addEventListener('click', function () {
          var m = main.swiper; if (!m) return;
          d === 'prev' ? m.slidePrev() : m.slideNext();
        });
        wrap.appendChild(b);
      });
    }
    var m = main.swiper;
    var update = function () {
      var s = main.swiper; if (!s) return;
      var total = sub.scrollHeight > sub.clientHeight + 2 || (sub.swiper && !sub.swiper.isLocked && sub.swiper.virtualSize > sub.clientHeight + 2);
      wrap.classList.toggle('pp-thumbs--overflow', !!total);
      wrap.classList.toggle('pp-thumbs--multi', sub.querySelectorAll('.product__media-subitem').length > 1);
      // few thumbnails (no overflow): pin the down arrow on the last thumbnail instead of the column bottom
      var next = wrap.querySelector('.pp-thumbs-nav--next'), items = sub.querySelectorAll('.product__media-subitem');
      if (!total && items.length) {
        var last = items[items.length - 1].getBoundingClientRect(), w = wrap.getBoundingClientRect();
        next.style.top = Math.round(last.bottom - w.top - (next.offsetHeight || 40) - 4) + 'px'; next.style.bottom = 'auto';
      } else { next.style.top = ''; next.style.bottom = ''; }
      wrap.querySelector('.pp-thumbs-nav--prev').disabled = s.isBeginning;
      wrap.querySelector('.pp-thumbs-nav--next').disabled = s.isEnd;
    };
    if (m && !m.__ppNav) { m.on('slideChange', update); m.__ppNav = true; }
    if (!wrap.__ppHover) { wrap.addEventListener('mouseenter', update); wrap.__ppHover = true; }
    update();
  }

  // zoom modal: a click anywhere that is not the photo or a control closes it (the theme only closed on the X / Esc)
  document.addEventListener('click', function (e) {
    var modal = e.target.closest && e.target.closest('product-modal[open]');
    if (!modal || e.target.closest('.js-image-zoom, button, a, .swiper-button-prev, .swiper-button-next, model-viewer, video, iframe')) return;
    var content = modal.querySelector('.product-media-modal__content');
    if (content) content.classList.remove('zoom');
    if (typeof modal.hide === 'function') modal.hide();
  });

  function run() {
    document.querySelectorAll('.product__outer--thumbs-aside').forEach(setup);
  }
  // the theme (re)creates the Swipers on load, resize and variant change: re-apply after it
  document.querySelectorAll('.product__outer--thumbs-aside').forEach(fit); // before first paint of the swiper sizes
  window.addEventListener('load', function () { setTimeout(run, 300); });
  window.addEventListener('resize', function () { setTimeout(run, 600); });
  document.addEventListener('variant:change', function () { setTimeout(run, 900); });
  new MutationObserver(function () { setTimeout(run, 500); })
    .observe(document.querySelector('.product-section') || document.body, { childList: true, subtree: false });
})();
